import React from 'react';

function AboutMe({visible, wasVisible, isMobile}){
	const visibility = !visible && visible == wasVisible ? "hidden" : "visible";
	const aboutMe = (
		<div className='about-me' style={{opacity: visible ? 1 : 0}}>
			<h3>Greetings! I'm</h3>
			<h1 className='marginless'>Viktor Lachinov</h1>
			<p className='sub-text marginless'>Full Stack Web Developer</p>
			<p>
				I am a <span className='highlight'>self-taught full stack developer </span>
				with over <span className='highlight'>5 years</span> of experience in
				my personal projects.<br/>Currently studying in <a href='https://en.venta.lv/' target='_blank'>Venstpils University</a> 1st
				course "Programmer specialist".
				<br/><br/>
				Solving <span className='highlight'>complex issues</span> and finding
				<span className='highlight'> optimal solutions</span> for completing
				various tasks is my speciality.
			</p>
		</div>
	)
	const freeTime = (
		<div className='about-me-personal pointer-none' style={{opacity: visible ? 1 : 0}}>
			<h3>In my free time I prefer to...</h3>
			<ul>
				<li>
					Surf the web in order to find something
					new that could help me in my career.
				</li>
				<li>
					Code my own projects
				</li>
				<li>
					Draw digital art
				</li>
				<li>
					Play some games with my friends
				</li>
			</ul>
			<p style={{marginBottom: "25px"}}>
				At the start, I might seem introversal,
				but in reality, I do like to talk.
			</p>
		</div>
	)
	if(isMobile){
		return (
			<>
				<div className="top-left pointer-none" style={{visibility, width: "100%"}}>
					{aboutMe}
					<div style={{float: "right", textAlign: "right"}}>
						{freeTime}
					</div>
				</div>
			</>
		)
	}else{
		return (
			<>
				<div className="top-left" style={{visibility, maxWidth: "30%"}}>
					{aboutMe}
				</div>
	
				<div className="bottom-right pointer-none" style={{visibility, maxWidth: "30%"}}>
					{freeTime}
				</div>
			</>
		)
	}
}

export default AboutMe;